module.exports = __webpack_public_path__ + "components/login/static/mountain-forecast_outside--header_logo-366bf244b619cf251e3b00835139441a.webp";